import * as Helper from '../helper/GlobalHelper'

// const url = 'https://europe-west1-aisw-ww-prod.cloudfunctions.net/beta_api_skyhook'
const url = `${process.env.REACT_APP_API_URL}/beta_api_skyhook`

export const getClubsById = async (ids: Array<string>) => {
  return await Helper.apiPost<any>(`${url}/backstaige/page/clubs`, { ids: ids })
}
